import type {
    ActionResponse,
    Exemplar,
    FinishedLendingActionResponse,
    FinishedReturningActionResponse,
    Loan, Pageable,
    RenewalResponse,
    User
} from 'typings/portaro.be.types';
import {ngAsync} from 'shared/utils/ng-@decorators';
import {transferify} from 'shared/utils/data-service-utils';
import type {AjaxService} from 'core/data-services/ajax.service';

export default class LoanDataService {

    public static serviceName = 'loanDataService';
    public static readonly ROUTE = 'loan-items';
    public static readonly NEW_LOAN_ROUTE = 'loan-items/new-loan';
    public static readonly RETURN_ROUTE = 'loan-items/return';
    public static readonly RENEW_ROUTE = 'loan-items/renew';


    /*@ngInject*/
    constructor(private ajaxService: AjaxService) {
    }

    @ngAsync()
    public async getById(loanId: string): Promise<Loan> {
        return this.ajaxService
            .createRequest(`${LoanDataService.ROUTE}/${loanId}`)
            .get();
    }

    @ngAsync()
    public async query(exemplarQ: string, pageable?: Pageable): Promise<Loan[]> {
        let queryParams = {exemplarQ};
        queryParams = pageable ? Object.assign({}, queryParams, pageable) : queryParams;

        return this.ajaxService
            .createRequest(`${LoanDataService.ROUTE}`)
            .get(queryParams);
    }

    @ngAsync()
    public async getByExemplarId(exemplarId: number, pageable?: Pageable): Promise<Loan[]> {
        let queryParams = {recordExemplar: exemplarId};
        queryParams = pageable ? Object.assign({}, queryParams, pageable) : queryParams;

        return this.ajaxService
            .createRequest(`${LoanDataService.ROUTE}`)
            .get(queryParams);
    }

    @ngAsync()
    public async lendExemplar(exemplar: Exemplar, lender: User, quantity?: number): Promise<FinishedLendingActionResponse> {
        return this.ajaxService
            .createRequest(`${LoanDataService.NEW_LOAN_ROUTE}`)
            .post({
                exemplar: transferify(exemplar, true),
                lender: transferify(lender, true),
                quantity
            });
    }

    @ngAsync()
    public async returnLoan(loan: Loan): Promise<FinishedReturningActionResponse> {
        return this.ajaxService
            .createRequest(`${LoanDataService.RETURN_ROUTE}`)
            .post({loan: loan.id});
    }

    @ngAsync()
    public async processLoan(loanId: string, exemplarId: number): Promise<ActionResponse> {
        return this.ajaxService
            .createRequest(`${LoanDataService.ROUTE}/${loanId}/process`)
            .post({exemplar: exemplarId});
    }

    @ngAsync()
    public async renewLoan(loan: Loan): Promise<RenewalResponse> {
        return this.ajaxService
            .createRequest(`${LoanDataService.ROUTE}/${loan.id}/renew`)
            .post(null);
    }

    @ngAsync()
    public async renewAllLoans(lender: User): Promise<ActionResponse> {
        return this.ajaxService
            .createRequest(`${LoanDataService.RENEW_ROUTE}`)
            .post({lender: lender.id, ignoreSomeLoansNotRenewed: true});
    }
}
